'use strict';
/***Roba Leo***/

let MarksButton = document.getElementById('show-markers-button');
let MarksButtonMobile = document.getElementById('show-markers-button-mobile');

let MarksCont = document.getElementById('markers-container');
let MarksArea = document.getElementById('markers-area');

let SearchButton = document.getElementById('show-search-button')
let SearchCont = document.getElementById('search-cont');

function toggleMarks() { 
  MarksCont.classList.toggle("markers-container-show");   
}

function toggleSearch() { 
  SearchCont.classList.toggle("search-container-show");
}

MarksButton.onclick = function() { 
	toggleMarks();
}
MarksButtonMobile.onclick = function() { 
	toggleMarks();
}

SearchButton.onclick = function() { 
	toggleSearch();
}


let mMedia = window.matchMedia("(max-width: 550px)")
myMediaFunc(mMedia) // Call listener function at run time
mMedia.addListener(myMediaFunc) // Attach listener function on state changes

function myMediaFunc(mMedia) {
  if (mMedia.matches) { // If media query matches
	  document.getElementById("search-form").id = "search-form-nope";
	  document.getElementById("search-form-mobile").id = "search-form";
  } else {
	  document.getElementById("search-form-mobile").id = "search-form-mobile";
  }
}


/***Roba Leo***/



import {mapspath,datapath,createGameMapType} from "./game_map_type";
import {createGeoJsonLayer} from "./geo_json_layer";
import {
    calculateFilterMarkers,
    clearCheckBoxes,
    clearCheckBoxesH,
    clearSearchBox,
    initCheckboxes,
    initSearchBox,
} from "./map";

let layerMarkers;
let map;


function initMap() {

    const mapsUrls = {
        "Normal": mapspath+"oblivion/normal",
        "Color": mapspath+"oblivion/color",
        "Terrain": mapspath+"oblivion/bump",
        "Game": mapspath+"oblivion/game"        
    };
    
    
    const myOptions = {
		center: new google.maps.LatLng(0,0),
		zoom: 3,
		zoomControl: true,
		mapTypeControl: true,
		scaleControl: true,
		streetViewControl: false,
		rotateControl: true,
		fullscreenControl: false,
		panControl: false,
		scaleControl: false,
		gestureHandling: 'greedy',
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.LARGE,
            position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        mapTypeControlOptions: {
            mapTypeIds: Object.keys(mapsUrls)
        }
    };

    const mapElement = document.getElementById('map_canvas');

    map = new google.maps.Map(mapElement, myOptions);
    for (let type in mapsUrls) {
        map.mapTypes.set(type, createGameMapType(type, mapsUrls[type]));
    }
    map.setMapTypeId('Normal');

    map.reset = () => {
        map.setCenter(myOptions.center);
        map.setZoom(myOptions.zoom);
    };

    layerMarkers = createGeoJsonLayer(datapath+'oblivion.geojson.gz');
    layerMarkers.setMap(map);

    initCheckboxes(layerMarkers, calculateFilterMarkers);
    initSearchBox(layerMarkers);
}

function resetMap () {
    clearSearchBox();
    clearCheckBoxes();
    if (layerMarkers) layerMarkers.setFilter((feature) => false);
    if (map) map.reset();
}

function zoomMap() {
    const mapBounds = new google.maps.LatLngBounds();

    if (layerMarkers) {
        const bounds = layerMarkers.getBounds();
        if (!bounds.isEmpty()) {
            mapBounds.extend(bounds.getNorthEast());
            mapBounds.extend(bounds.getSouthWest());
        }
    }

    if (!mapBounds.isEmpty()) {
        map.fitBounds(mapBounds);
        if (map.getZoom() < 2) {
            map.setZoom(2);
        }
    }
}

window.zoomMap = zoomMap;
window.resetMap = resetMap;
window.initMap = initMap;
